import BotTestConclusionImage from '@/assets/bot-test-conclusion-image.webp'
import OpacityAnimation from '@/components/animations/OpacityAnimation'
import { Column, Text } from '@/components/core'
import AvatarCard from '@/components/layout/AvatarCard.tsx'

export default function Completed() {
  return (
    <OpacityAnimation className="h-full w-full">
      <Column className="h-full w-full items-center justify-center">
        <Column
          className={`h-full max-h-[640px] w-full max-w-[720px] overflow-hidden rounded-2xl`}
        >
          <AvatarCard
            variant="image"
            botAvatar={BotTestConclusionImage}
            animate={false}
          >
            <Column className="items-center">
              <Text.Translated
                size="3xl"
                className="!text-electric-indigo-900"
                fontWeight="bold"
                translationKey="test_completed_processing_result_states"
              />
              <Text.Translated
                color="600"
                align="center"
                className="my-[18px] text-lg"
                translationKey="test_success_message_processing_result_states"
              />
            </Column>
          </AvatarCard>
        </Column>
      </Column>
    </OpacityAnimation>
  )
}
